/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import RoundedButton from '../buttons/Rounded';
import SmallTicketIcon from '../icons/SmallTicket';
import Body from './Body';

import styles from '../../../styles/partials/ticket-price.module.scss';

const propTypes = {
    label: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
    price: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    label: null,
    description: null,
    url: null,
    price: null,
    className: null,
};

const TicketPrice = ({ label, description, url, price, className }) => (
    <div
        className={classNames(styles.container, {
            [className]: className !== null,
        })}
    >
        {label !== null || description !== null ? (
            <div className={styles.ticketContent}>
                {label !== null ? <h3 className={styles.label}>{label}</h3> : null}
                {description !== null ? (
                    <Body className={styles.description} body={description} />
                ) : null}
            </div>
        ) : null}

        <div className={styles.priceInfo}>
            {price !== null ? <div className={styles.price}>{price}</div> : null}

            {url !== null ? (
                <RoundedButton
                    className={styles.button}
                    href={url}
                    external
                    icon={<SmallTicketIcon />}
                    iconPosition="left"
                >
                    <FormattedMessage defaultMessage="Buy" description="Button label" />
                </RoundedButton>
            ) : null}
        </div>
    </div>
);
TicketPrice.propTypes = propTypes;
TicketPrice.defaultProps = defaultProps;

export default TicketPrice;
